export default "__VITE_ASSET__117e79bb__"